import { Component } from '@angular/core';
import { GaSpinnerModule } from '@vsn-ux/ngx-gaia';

@Component({
  selector: 'di-loading',
  template: `
    <div
      class="tw:fixed tw:inset-0 tw:bg-white tw:z-[9999] tw:flex tw:items-center tw:justify-center tw:w-screen"
    >
      <div class="tw:flex tw:flex-col tw:items-center">
        <ga-spinner class="tw:mb-4" size="48" />
        <p class="tw:text-lg tw:text-gray-700" i18n>Loading...</p>
      </div>
    </div>
  `,
  imports: [GaSpinnerModule],
})
export class LoadingComponent {}
